import React from 'react';
import KickImage from 'Reuseables/KickImage';

type SwitchToggleProps = {
  handleToggleKickPoint: () => void
  isKickPointActive: boolean
  disabled: boolean
}

const SwitchToggle: React.FC<SwitchToggleProps> = ({ handleToggleKickPoint, isKickPointActive, disabled }): JSX.Element => {
  return (
    <div onClick={() => !disabled && handleToggleKickPoint()} className={`payment-toggle-switch ${isKickPointActive ? "toggleActive" : ""}`}>
      <div className={`knob ${isKickPointActive ? "knobActive" : ""}`} />
    </div>
  )
}

export default SwitchToggle
